import Accordion from "../../plugins/accordion.js";
const elements = document.querySelectorAll(".js-accordion");
let accordion = "";

for (const element of elements) {
  accordion = new Accordion(element, {
    duration: ".3s",
    multipleOpen: true,
  });
}

//ハッシュタグがあった場合の処置
class accordionHash {
  constructor() {
    this.body = document.querySelector("body");
    this.triggers = document.querySelectorAll(".js-accordion-trigger");
    this.panels = document.querySelectorAll(".js-accordion-panel");
    this.hash = location.hash;
  }
  init() {
    this.attachEvent();
  }

  getTargetId(target) {
    return target.getAttribute("id");
  }

  removeSelected() {
    for (let trigger of this.triggers) {
      trigger.setAttribute("aria-selected", "false");
    }
  }

  setHidden() {
    for (let panel of this.panels) {
      panel.setAttribute("aria-hidden", "true");
      panel.style.display = "none";
    }
  }

  attachEvent() {
    this.triggers.forEach((trigger, index) => {
      if (this.hash.replace("#q", "") == index + 1) {
        trigger.setAttribute("aria-expanded", "true");
        setTimeout(function () {
          $("header").addClass("h_close");
        }, 30);
        console.log(this.hash);
      }
    });
    this.panels.forEach((panel, index) => {
      if (this.hash.replace("#q", "") == index + 1) {
        // this.setHidden();
        panel.setAttribute("aria-hidden", "false");
        panel.setAttribute("data-accordion-default-open", "");
        accordion.destroy();
        accordion.init();
        // panel.style.display = "block";
      }
    });
  }
}
const accordionhash = new accordionHash();

if (elements.length) {
  const mediaQueryList = window.matchMedia("(min-width:768px)");

  /**
   * イベントリスナー
   */
  const listener = (event) => {
    // リサイズ時に行う処理
    if (event.matches) {
      // 768px以上
      accordion.destroy();
      // console.log('PC用ブレークポイント用処理');
    } else {
      // 768px未満
      accordion.init();
      // console.log('SP用ブレークポイント用処理');
      accordionhash.init();
    }
  };

  // リスナー登録
  mediaQueryList.addEventListener("change", listener);

  // 初期化処理
  listener(mediaQueryList);
}
